import { useSelector } from "react-redux";
import { CartoLayer, colorBins } from "@deck.gl/carto";
import { selectSourceById } from "@carto/react-redux";
import { useCartoLayerProps } from "@carto/react-api";
import htmlForFeature from "utils/htmlForFeature";
import { VISUALS } from "data/config.js";

export const VISITORS_TO_POINT_LAYER_ID = "visitorsToPointLayer";

export default function VisitorsToPointLayer() {
  const { visitorsToPointLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, visitorsToPointLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });
  const breaks = useSelector((state) => state.app.breaks);
  const day = useSelector((state) => state.app.day);
  const window = useSelector((state) => state.app.window);

  if (visitorsToPointLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: VISITORS_TO_POINT_LAYER_ID,
      getFillColor: colorBins({
        attr: VISUALS.attr,
        domain: breaks,
        colors: VISUALS.primary_palette,
      }),
      //getElevation: f => Math.sqrt(f.properties.n_visitors) * 10,
      getElevation: 2000,
      getLineWidth: 0,
      visible: visitorsToPointLayer.visible,
      pickable: true,
      opacity: 0.5,
      autoHighlight: true,
      highlightColor: [71, 219, 153],
      // extruded: true,
      // getElevation: (data) => {console.log(data); return data.properties.n_visitors*0.002},
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: [VISUALS.attr],
              formatter: {
                type: "number",
                columns: [VISUALS.attr],
              },
            }),
            style: { getFillColor: "white" },
          };
        }
      },

      updateTriggers: {
        getFillColor: [breaks, day, window],
        ...cartoLayerProps.updateTriggers,
      },
    });
  }
}
